import { Check, FileText, ListChecks, Film } from "lucide-react";

export const STEPS = [
    { key: "document", label: "Document", icon: FileText },
    { key: "script", label: "Script & scenes", icon: ListChecks },
    { key: "video", label: "Video", icon: Film },
];

export function ProjectStepper({ step, doneUpTo, onChange }) {
    const doneIdx = STEPS.findIndex((s) => s.key === doneUpTo);
    return (
        <ol data-testid="project-stepper" className="flex items-center gap-2">
            {STEPS.map((s, i) => {
                const active = s.key === step;
                const done = i < doneIdx;
                const Icon = done ? Check : s.icon;
                return (
                    <li key={s.key} className="flex items-center gap-2">
                        <button
                            type="button"
                            data-testid={`step-${s.key}`}
                            onClick={() => onChange(s.key)}
                            className={`flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm transition-colors ${
                                active ? "border-neutral-900 bg-neutral-900 text-white"
                                    : done ? "border-emerald-200 bg-emerald-50 text-emerald-800"
                                        : "border-neutral-200 bg-white text-neutral-600 hover:bg-neutral-50"
                            }`}
                        >
                            <Icon size={14} />
                            <span>{i + 1}. {s.label}</span>
                        </button>
                        {i < STEPS.length - 1 && <span className="h-px w-6 bg-neutral-300" />}
                    </li>
                );
            })}
        </ol>
    );
}
